import { useEffect, useState } from 'react';
import { getPublicStats } from '../services/publicStatsService';

export function usePublicStats(periods, section) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatedAt, setUpdatedAt] = useState(null);

  // Periods is a fresh array every render, so depend on its serialised form instead.
  const periodsKey = JSON.stringify(periods);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    getPublicStats(JSON.parse(periodsKey), section)
      .then((data) => {
        if (!mounted) return;
        setStats(data);
        setUpdatedAt(new Date());
      })
      .catch(() => {
        if (mounted) setStats(null);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [periodsKey, section]);

  return { stats, loading, updatedAt };
}
